const config = {
  WEBRTC_LOG: false,
  WEBINAR_DEBUG: false,
  SOCKET_IO_DEBUG: false,
  JANUS_HOST: 'wss://workshop.tokyo/janus',
  API_HOST: 'workshop.tokyo',
  TURN_HOST: 'turn.workshop.tokyo',
  SOCKET_HOST: 'workshop.tokyo',
  WEBINAR_ADMIN_URL: 'https://admin-dev.workshop-live.com',
  DD_ADMIN_URL: 'https://admin-dev.dd-talk.net/',
  SHARE_URL : "https://video-dev.dd-talk.net",
  SPACEE_DEBUG: false,
  FVLITE_DEBUG: false,
  FIREBASE_BASE: 'prod',
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDsddDaw6PK6UO_Ht8m5Blq5uTrAHnPOO8",
    authDomain: "workshop-video-prod.firebaseapp.com",
    databaseURL: "https://workshop-video-prod.firebaseio.com",
    projectId: "workshop-video-prod",
    storageBucket: "workshop-video-prod.appspot.com",
    messagingSenderId: "447629060783"
  },
  WEBINAR_DEV_TEST2_DEBUG_TOKEN : "eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJjb25mZXJlbmNlX2lkIjoyNzksInVzZXJfaWQiOjYzLCJhZG1pbiI6InllcyIsImNvbmZlcmVuY2VfbmFtZSI6InRlc3QyLXdlYnJ0Yy1kZXYxLmZyZXNodm9pY2UuYXNpYSIsImNvbmZlcmVuY2VfZGVzY3JpcHRpb24iOm51bGx9.",
  WEBINAR_PROD_TEST2_DEBUG_TOKEN : "eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJjb25mZXJlbmNlX2lkIjoxNTcwLCJ1c2VyX2lkIjoxNiwiYWRtaW4iOiJ5ZXMiLCJjb25mZXJlbmNlX25hbWUiOiJwcm9kMi13b3Jrc2hvcC50b2t5byIsImNvbmZlcmVuY2VfZGVzY3JpcHRpb24iOm51bGx9.",
  SENTRY: "https://f623b27a747d4f11830f4ff1bc414198@sentry.io/1477210",
  GIT_HASH: "fb323f2",
  GIT_BRANCH: "release"
}
export default config




// WEBPACK FOOTER //
// ./src/config/config.js